import { Reveal, Eyebrow } from "./Reveal";

const AUDIENCES = [
  {
    title: "Petits commerces & boutiques locales",
    desc: "Montrez votre vitrine, vos horaires et vos produits pour attirer le chaland du quartier.",
    img: "https://images.pexels.com/photos/7679757/pexels-photo-7679757.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Intérieur moderne d'une boutique de prêt-à-porter",
  },
  {
    title: "Artisans & métiers de bouche",
    desc: "Faites valoir votre savoir-faire avec des photos de vos réalisations qui rassurent.",
    img: "https://images.pexels.com/photos/5710904/pexels-photo-5710904.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Menuisier façonner le bois dans son atelier professionnel",
  },
  {
    title: "Avocats & petits cabinets",
    desc: "Une présence sérieuse et claire : domaines d'intervention, parcours, prise de contact.",
    img: "https://images.pexels.com/photos/159720/justice-law-case-hearing-159720.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Ouvrages de droit alignés dans une bibliothèque de cabinet",
  },
  {
    title: "Agents immobiliers & mandataires",
    desc: "Mettez en avant vos biens, vos secteurs et ce que disent vos clients.",
    img: "https://images.pexels.com/photos/8112163/pexels-photo-8112163.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Agent immobilier remettant des clés à ses clients",
  },
  {
    title: "Professions libérales",
    desc: "Santé, experts-comptables, consultants : soignez votre première impression en ligne.",
    img: "https://images.pexels.com/photos/39192382/pexels-photo-39192382.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Consultation médicale dans un cabinet moderne",
  },
  {
    title: "Indépendants & freelances",
    desc: "Un portfolio net qui présente vos services et déclenche les premiers contacts.",
    img: "https://images.pexels.com/photos/3201587/pexels-photo-3201587.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Freelances travaillant sur leurs ordinateurs",
  },
];

export const Audiences = () => (
  <section id="metiers" className="py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <Reveal>
          <Eyebrow>Pour qui</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-5 font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
            Pensé pour les professionnels de terrain.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            Six métiers, une même exigence : un site qui vous ressemble et qui transforme vos
            visiteurs en clients.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2">
        {AUDIENCES.map((a, i) => (
          <Reveal key={a.title} delay={(i % 2) * 0.08} className="h-full">
            <article
              data-testid={`audience-card-${i}`}
              className="group h-full overflow-hidden rounded-3xl border border-navy/10 bg-white transition-all duration-300 hover:-translate-y-1 hover:border-gold/40 hover:shadow-xl hover:shadow-gold/10"
            >
              <div className="overflow-hidden">
                <img
                  src={a.img}
                  alt={a.alt}
                  loading="lazy"
                  className="h-48 w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-6">
                <h3 className="font-display text-lg font-bold text-navy">{a.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{a.desc}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
